/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { ReactComponent as CallIncomingIcon } from '../../../../shared/assets/svg/call-incoming.svg';
import { ReactComponent as SwitchIcon } from '../../../../shared/assets/svg/switch.svg';
import { ReactComponent as CallRecordingIcon } from '../../../../shared/assets/svg/call-recording.svg';

export const FEATURES = [
  {
    featureLabel: 'Multiple incoming and outgoing calls',
    desc: 'Monitor multiple incoming and outgoing calls simultaneously',
    icon: CallIncomingIcon,
    iconColor: '#3D906D',
  },
  {
    featureLabel: 'Call recordings',
    desc: 'Automatically record and download all calls for easy review and analysis',
    icon: CallRecordingIcon,
    iconColor: '#EF5350',
  },
  {
    featureLabel: 'Call logs',
    desc: 'Keep track of all your calls. Easily review and analyse your call history',
    icon: SwitchIcon,
    iconColor: '#596BD7',
  },
];

export const WA_VOICE_TRIAL_DISMISSED = 'wa_voice_trial_dismissed';

export const autoOpenAnimationCss = css`
  @keyframes trialModalFadeIn {
    from {
      opacity: 0;
      transform: scale(0.96);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
  animation: trialModalFadeIn 0.35s ease-out;
`;
